import { useState, useEffect, useCallback } from 'react'

import { ITEM_SCROLL_RESTORATION_KEY } from '../constants'
import {
  saveToSessionStorage,
  readFromSessionStorage,
  deleteFromLocalStorage,
} from '../helpers'

const usePersistElementScrollPosition = ({
  id,
  ref,
  deactivated = false,
} = {}) => {
  useEffect(() => {
    if (
      !deactivated &&
      typeof window !== 'undefined' &&
      'scrollRestoration' in history &&
      history.scrollRestoration !== 'manual'
    ) {
      history.scrollRestoration = 'manual'
    }
  }, [deactivated])

  const persistScrollPosition = useCallback(() => {
    if (!deactivated) {
      saveToSessionStorage(ITEM_SCROLL_RESTORATION_KEY, id)
    }
  }, [id, deactivated])

  const [markerId, setMarkerId] = useState(() => {
    const persistedId = readFromSessionStorage(ITEM_SCROLL_RESTORATION_KEY)
    if (persistedId) {
      deleteFromLocalStorage(ITEM_SCROLL_RESTORATION_KEY)
    }
    return persistedId ? persistedId : ''
  })

  useEffect(() => {
    if (ref?.current?.scrollIntoView && markerId === id && !deactivated) {
      ref.current.scrollIntoView({ behavior: 'auto', block: 'center' })
      deleteFromLocalStorage(ITEM_SCROLL_RESTORATION_KEY)
      setMarkerId('')
    }
  }, [id, markerId, ref, deactivated])

  return { persistScrollPosition }
}

export default usePersistElementScrollPosition
